<template>
  <div>
    <div class="upload-photo">
      <div class="upload-list" v-for="(item,index) in uploadList" :key="index">
        <div style="height:100%" v-if="item.status === 'finished'">
          <img :src="item.url|img_oss('tubo_tiny')">
          <div class="upload-list-cover">
            <Icon type="ios-eye-outline" v-image-preview="{item:item.url,list:uploadList.map(item=>item.url)}"></Icon>
            <Icon type="ios-trash-outline" @click.native="handleRemove(item,uploadList)" v-show="!disabled"></Icon>
          </div>
        </div>
        <div v-else>
          <Progress :percent="item.percentage"></Progress>
        </div>
      </div>
      <div class="upload-list c-h" @click="readCardCaram">
        <Icon type="ios-camera" style="width:58px;height:58px" size="20"></Icon>
      </div>
    </div>
  </div>
</template>
<script>
  import { _api, util, _http } from '@/libs';
  export default {
    name: 'PhotoUploadCaram',
    model: { prop: 'img', event: 'change' },
    props: {
      // 双向绑定字段(single==true返回ossPath字符串，single==false返回字符串数组)
      img: { type: [String, Array] },
      // 禁用组件
      disabled: Boolean,
      // 单图多图，默认单图
      single: { type: Boolean, default: true },
      // 上传方式 ('select':图片选择框,'drag':拖拽)
      type: { type: String, default: 'select' },
      // 上传api
      action: { type: String, default: () => { return _api.baseUrl + _api.common.libThird.oss } },
      // 上传参数
      param: { type: Object, default: () => { return {} } },
      // 上传成功回调
      success: { type: Function }
    },
    data() {
      return {}
    },
    computed: {
      uploadList: {
        get() {
          return this.img ? typeof this.img == 'string' ? [{ name: this.img, url: this.img, status: 'finished' }] : this.img.map(item => { return { name: item, url: item, status: 'finished' } }) : []
        },
        set() {
          return this.uploadList
        }
      }
    },

    methods: {
      // 高拍仪读取法人代表证件反面
      readCardCaram() {
        const _this = this
        if (util.ctlActivelSealSupoot(Test, this)) {
          util.promise(this, () => util.toJson(Test.ExecScanBase64("IDR270.2"))).then(payload => {
            if (payload.img) {
              const file = {}
              _http({ method: 'post', url: _this.action, data: Object.assign(_this.param, { fileBase64: payload.imgUrl }), onUploadProgress(res) { 
                Object.assign(file, { percentage: res.total / res.size * 100 })
               } }).then(data => {
                Object.assign(file, Object.assign(data, { name: data.ossPath, url: data.ossPath, status: 'finished' }))
                if (_this.single) {
                  _this.uploadList = [data]
                  _this.$emit('change', data.ossPath)
                } else {
                  _this.$emit('change', _this.uploadList.filter(item => item.status == 'finished').map(item => item.url))
                }
                if (_this.success) {
                  _this.success(data, payload, _this.uploadList)
                }
                _this.$forceUpdate()
              })
              _this.uploadList.push(file)
            }
          })
        }
      },

      // 删除图片
      handleRemove(item, arr) {
        if (this.single) {
          this.uploadList = []
          this.$emit('change', null)
        } else {
          arr.splice(arr.indexOf(item), 1)
          this.$emit('change', this.uploadList.filter(item => item.status == 'finished').map(item => item.url))
        }
      }
    },
  }
</script>